import { useEffect, useMemo } from 'react'

import { useDocumentStore } from '@/features/document'
import { ResponseDocumentListItem } from '@/schema'

import { TFLUtils } from '../mappers'
import { useTflViewerStore } from '../store'
import { compareDocs } from '../utils/parser'

export const useTFLSidebarDocuments = (
  data: ResponseDocumentListItem[],
  deliverableSetId?: string
) => {
  const { setDocumentMetadata } = useTflViewerStore()
  const { deleteMultipleDocumentIds } = useDocumentStore()

  const sortedData = useMemo(() => data.sort(compareDocs), [data]) // NOSONAR

  const isSelectAll = useMemo(
    () => deleteMultipleDocumentIds.length === data.length,
    [deleteMultipleDocumentIds, data]
  )

  useEffect(() => {
    if (sortedData.length > 0 && deliverableSetId) {
      sortedData.forEach((item) => {
        const mappedData = TFLUtils.mappingFromTOCItem(item)
        const dataWithDsId = {
          ...mappedData,
          dsId: deliverableSetId,
        }
        setDocumentMetadata(item.document_id, dataWithDsId)
      })
    }
  }, [sortedData, deliverableSetId, setDocumentMetadata])

  return { sortedData, isSelectAll }
}
